import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1 className="privacy-title">Privacy Policy</h1>
      <p className="effective-date">Effective Date: May 24, 2025</p>
      
      <p className="privacy-intro">
        We respect your privacy. This policy explains what data we collect, how we use it, and your rights.
      </p>

      <section className="privacy-section">
        <h2 className="section-title">1. What We Collect</h2>
        <div className="section-content">
          <p>We may collect:</p>
          <ul>
            <li>Your name, phone number, email, and location</li>
            <li>Photos you upload</li>
            <li>Order history, reviews, and messages</li>
            <li>Technical data (device info, usage patterns, cookies)</li>
          </ul>
        </div>
      </section>

      <section className="privacy-section">
        <h2 className="section-title">2. How We Use Your Data</h2>
        <div className="section-content">
          <p>We use your information to:</p>
          <ul>
            <li>Operate and improve the platform</li>
            <li>Facilitate transactions</li>
            <li>Communicate with you</li>
            <li>Prevent fraud and enforce policies</li>
          </ul>
          <p>We may also use aggregated, anonymized data for analytics and product development.</p>
        </div>
      </section>

      <section className="privacy-section">
        <h2 className="section-title">3. Sharing Your Data</h2>
        <div className="section-content">
          <p>We do not sell your data.</p>
          <p>We may share limited data with:</p>
          <ul>
            <li>Payment processors</li>
            <li>Hosting and analytics partners</li>
            <li>Law enforcement, when legally required</li>
          </ul>
        </div>
      </section>

      <section className="privacy-section">
        <h2 className="section-title">4. Your Rights</h2>
        <div className="section-content">
          <p>You can:</p>
          <ul>
            <li>Access your data</li>
            <li>Correct your data</li>
            <li>Delete your account</li>
            <li>Request to opt out of marketing emails</li>
          </ul>
          <p>To request any of the above, contact us at [support@example.com].</p>
        </div>
      </section>

      <section className="privacy-section">
        <h2 className="section-title">5. Data Security</h2>
        <div className="section-content">
          <p>We take reasonable steps to protect your data, but no platform is 100% secure. Use the platform at your own discretion.</p>
        </div>
      </section>

      <section className="privacy-section">
        <h2 className="section-title">6. Changes to This Policy</h2>
        <div className="section-content">
          <p>We may revise this policy over time. We'll notify users of significant updates.</p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
